
import { Component, Prop } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import AttachmentMixin from '@/_mixins/attachment'

@Component({
    mixins: [AttachmentMixin],
})
export default class ContractorInfo extends Mixins<MixinInterface>(AttachmentMixin) {
    @Prop() contractor!: Record<string, any>
    @Prop({ default: false, required: true }) isWritable!: boolean

    get contractorName() {
        return this.contractor.namePath[this.contractor.namePath.length - 1]
    }

    highlight = false

    highlightChip() {
        this.highlight = true
        setTimeout(() => {
            this.highlight = false
        }, 1000)
    }
}
